import React, { useRef, useState } from 'react';
import { Avatar, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

function UpdateImageUpload({ label, value, onChange, error, helperText, image, setFormValues }) {
    const theme = useTheme();
    const inputRef = useRef();
    const [preview, setPreview] = useState(image);
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));


    const height = () => {
        if (isTablet) return '20vw';
        else return '18vw';
    }
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const filePreview = URL.createObjectURL(file);
            setPreview(filePreview);
            if (onChange) {
                onChange(file);
            }
            setFormValues((prevValues) => ({
                ...prevValues,
                [value]: false,
            }));
        }
    };

    const handleButtonClick = () => {
        inputRef.current.click();
    };

    const handleRemoveImage = () => {
        setPreview(null);
        if (onChange) {
            onChange(null);
        }
        setFormValues((prevValues) => ({
            ...prevValues,
            [value]: true,
        }));
        inputRef.current.value = null;
    };


    return (
        <Box>
            <Typography
                style={{
                    color: theme.palette.text.primary,
                    fontSize: 13,
                    marginTop: 24,
                    marginBottom: 4,
                }}
            >
                {label}
            </Typography>
            <input
                type="file"
                ref={inputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept="image/*"
            />
            <Box sx={{
                display: 'flex'
            }}>
                <Avatar
                    variant="rounded"
                    onClick={handleButtonClick}
                    src={preview}
                    sx={{
                        cursor: 'pointer',
                        width: '100%',
                        height: height,
                    }}
                />
                <Box sx={{
                    color: theme.palette.text.red,
                    mx: 1,
                    cursor: 'pointer'
                }}>
                    <CloseOutlinedIcon onClick={handleRemoveImage} />
                </Box>
            </Box>

            {helperText && (
                <Typography
                    style={{
                        color: error ? theme.palette.error.main : theme.palette.text.secondary,
                        fontSize: 12,
                        marginTop: 4,
                    }}
                >
                    {helperText}
                </Typography>
            )}
        </Box>
    );
}

export default UpdateImageUpload;
